import { TColumnsResolver } from '../../../../common/types/TColumnsResolver';

export const DisclosureDetailColumnResolver: TColumnsResolver = (
  col: any,
  row: any,
): string | JSX.Element | undefined => {
  let cellValue;
  if (col.name === 'factName') {
    cellValue = `${row.factName ? row.factName : '-'}`;
  } else if (col.name === 'value') {
    cellValue = `${row.value ? row.value : '-'}`;
  } else if (col.name === 'attributes') {
    cellValue = '-';
    if (row.attributes) {
      const attributesList = row.attributes
        .filter((att: any) => att.attributeName !== 'is_independent')
        .map((att: any) => {
          return { [att.attributeName]: att.value };
        });
      cellValue = JSON.stringify(attributesList);
    }
  }

  return cellValue;
};
